import { FILTER_CONTEXT_LABELS, FILTER_CONTEXTS } from "@search/api/constants";
import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class OnlineExclusiveFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: FILTER_CONTEXT_LABELS[FILTER_CONTEXTS.online_exclusive],
      name: "onlineExclusive",
      value,
    });
  }
}

export default OnlineExclusiveFilter;
export { OnlineExclusiveFilter };
